<template>
    <ion-header slot="fixed">
        <router-link :to="{ name: 'Index' }">
            <div class="logo no-select">
                <svg-vox-partners-club :color="'#ffffff'"/>
            </div>
        </router-link>
        <div class="nav" v-if="isAuthenticated">
            <div class="notification-wrapper">
                <span v-if="showBadgeNotifications && unreadNotifications.length > 0" class="notification-counter">
                    <span v-if="unreadNotifications.length > 99">99</span>
                    <span v-else>{{ unreadNotifications.length }}</span>
                </span>
                <svg class="voxion icon-bell" @click="goToNotifications"><use xlink:href="#icon-bell"></use></svg>
            </div>
            <svg class="voxion icon-burger hidden-lg-up" @click="openSideMenu"><use xlink:href="#icon-burger"></use></svg>
        </div>
    </ion-header>
</template>

<script>
    import { mapGetters } from 'vuex'
    import SvgVoxPartnersClub from "./svgplus/SvgVoxParntersClub.vue";
    //
    import Platform from '../helpers/Platform.js';
    import Badge from '@/services/Badge';

    export default {
        components: {SvgVoxPartnersClub},
        name: 'MainHeader',
        computed: {
            ...mapGetters(['isAuthenticated', 'getNotifications', 'showBadgeNotifications']),
            unreadNotifications(){
                let unreadNotifications = this.getNotifications.filter((o) => { return o.isRead == false; });
                //
                if (unreadNotifications.length > 0) {
                  Badge.setBadge(1);
                  // Badge.setBadge(unreadNotifications.length);
                }else{
                  Badge.clearBadge()
                }
                //
                return unreadNotifications;
            }
        },
        methods: {
            openSideMenu () {
                this.$parent.$refs.menuController.open('mainMenu');
            },
            goToNotifications () {
                this.$router.push({ name: 'UserNotifications' })
            }
        }
    }
</script>
